import { MarkedOptions, MarkedRenderer } from 'ngx-markdown';

/**
 * Builds the global `marked` options consumed by `MarkdownModule.forRoot` in `app.config.ts`.
 *
 * Every rendered link (markdown links and GFM autolinked URLs) opens in a new tab so that
 * following a link from chat content does not navigate away from the active session.
 *
 * @remarks
 * `target` and `rel` are on Angular's sanitizer allowlist, so they survive ngx-markdown's
 * default `SecurityContext.HTML` sanitization. `rel="noopener noreferrer"` prevents the
 * opened page from accessing `window.opener`.
 *
 * @returns Options for ngx-markdown's `MARKED_OPTIONS` provider.
 */
export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();
  const defaultLink = renderer.link;

  renderer.link = function (token) {
    return defaultLink
      .call(this, token)
      .replace(/^<a /, '<a target="_blank" rel="noopener noreferrer" ');
  };

  return {
    gfm: true,
    breaks: true,
    renderer,
  };
}
